const StepEnum = {
  BrandSelect: 0,
  RackSelect: 1,
  ThirdParty: 2,
  NoRack: 3,
  NoFit: 4,
};

export default StepEnum;
